import shallow from "zustand/shallow";
import { useStoreSystem } from "../store";

export const useSettings = () => {
    const { updateSettings, isVisibleSizes } = useStoreSystem((state) => ({
        updateSettings: state.updateSettings,
        isVisibleSizes: state.settings.isVisibleSizes
    }), shallow);

    return {
        isVisibleSizes,
        updateSettings,
    };
};
